import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../helpers/Records';
import { construct, fields, resolve } from '../../../helpers/LinkMapper';
import { serialize, serializers } from '../../../helpers/SearchUrls';
import trainTime from '../../../lib/TrainTime';

import DatePeriod from './DatePeriod';
import TimePeriod from './TimePeriod';
import CalculationBreakdown from './CalculationBreakdown';
import { translate as t } from "../../../lib/I18n";

const fieldSchema = {
    ticketId: [ fields.number ],
    collected: [ fields.boolean ],
    originalAmount: [ fields.number ],
    refundAmount: [ fields.number ],
    totalUsed: [ fields.number ],
    surrenderDate: [ resolve.with(trainTime) ],
    durationUsed: [ resolve.as(TimePeriod) ],
    dateUsed: [ resolve.as(DatePeriod) ],
    dateUnused: [ resolve.as(DatePeriod) ],
    breakdown: [ resolve.as(CalculationBreakdown) ],
};

function _formatDatePair (from, to) {
    const _formatDate = (date) => { return date && date.format('ddd DD MMM YYYY'); };
    if (from.isSame(to)) {
        return _formatDate(from);
    } else if (from.isBefore(to)) {
        return t('account.orders.refund.itso.datePeriodPair',
            { startDate: _formatDate(from), endDate: _formatDate(to) });
    } else {
        return '-';
    }
}

class Calculation extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(Calculation, json, getResolvers(fieldSchema));
    }

    serialize () {
        return serialize({
            ticketId: serializers.identity,
            collected: serializers.identity,
            originalAmount: serializers.identity,
            refundAmount: serializers.identity,
            totalUsed: serializers.identity,
            surrenderDate: serializers.isoDateTime,
            durationUsed: serializers.identity,
            dateUsed: serializers.serializedIdentity,
            dateUnused: serializers.serializedIdentity,
            breakdown: serializers.identity
        }, this);
    }

    getUsedDates () {
        const from = this.dateUsed.from.clone().startOf('day');
        const to = this.dateUsed.to.clone().startOf('day');
        return _formatDatePair(from, to);
    }

    getUnusedDates () {
        const from = this.dateUnused.from.clone().startOf('day');
        const to = this.dateUnused.to.clone().startOf('day');
        return _formatDatePair(from, to);
    }

    get availableToRefund () {
        return this.refundAmount > 0 ? this.refundAmount : 0;
    }

    isIncomplete () {
        return this.getIn(['breakdown', 'isIncomplete']);
    }
}

export default Calculation;
